// Registration Actions Constants

export const PARTNER_REGISTRATION_EMAIL_INVALID =
  "PARTNER_REGISTRATION_EMAIL_INVALID";
export const PARTNER_REGISTRATION_REGISTERED_COMPANIES =
  "PARTNER_REGISTRATION_REGISTERED_COMPANIES";
export const PARTNER_REGISTRATION_STATUS = "PARTNER_REGISTRATION_STATUS";
export const LOAD_COMMON_HEADERS = "LOAD_COMMON_HEADERS";
export const SET_PROGRAM_TYPE = "SET_PROGRAM_TYPE";
export const SET_ERROR_CODE = "SET_ERROR_CODE";
export const SET_USER_LOGGED_IN = "SET_USER_LOGGED_IN";
export const SET_IMS_PROFILE_EXISTS = "SET_IMS_PROFILE_EXISTS";
export const SET_PARTNER_REGISTRATION_FORM_STEP =
  "SET_PARTNER_REGISTRATION_FORM_STEP";
export const SET_SELECTED_REGISTER_COMPANY_TYPE =
  "SET_SELECTED_REGISTER_COMPANY_TYPE";
export const SET_DXP_USER_PROFILE_DRAFT = "SET_DXP_USER_PROFILE_DRAFT";
